import breakpoints from "./breakpoints";

export default Object.entries(breakpoints).reduce(
  (queries, [breakpoint, value]) => ({
    ...queries,
    [breakpoint]: `(min-width: ${value}px)`,
  }),
  {}
);
